import React, { useState } from "react"
import { useSelector } from "react-redux"
import { useParams } from "react-router-dom"

import { selectScopedByClient, selectScopedClient } from "../../../stores/appSlice"

// Loaded as a URL into an <img> rather than inlined via `ReactComponent`. MucLogoCircle.svg
// and the nav's muc-logo-v2.svg both define .st0-.st3 with different values, and an inlined
// SVG's <style> block is document-scoped — inlining this one would restyle the header logo
// (its .st0 elements would inherit display:none). An <img> isolates the SVG's own styles.
import mucLogoUrl from "../../../assets/images/MucLogoCircle.svg"

// Rendered in place of the retired dashboard views. See Dashboard.jsx for context. Shows the
// scoped client's own logo when they have one (the same `file_url` the header logo uses, see
// MucLogoHorizontal.jsx), falling back to the MUC logo otherwise.
export default function DashboardPlaceholder() {
    const { clientId } = useParams()
    const scopedClient = useSelector(selectScopedClient)
    const scopedByClient = useSelector(selectScopedByClient)
    const [failedLogoUrl, setFailedLogoUrl] = useState(null)

    // HeaderDropdown dispatches fetchAndSetScopedClient whenever the URL's clientId doesn't
    // match scopedByClient. Until that resolves, scopedClient is null (first load) or still
    // the previous client's record (switching clients), so render no logo at all rather than
    // flashing the MUC logo ahead of the client's or showing the wrong client's branding.
    const clientResolved = !clientId || String(scopedByClient) === String(clientId)

    const clientLogoUrl = scopedClient?.file_url
    // Track the failed URL rather than a boolean: this component stays mounted across a client
    // switch, and a boolean would suppress the next client's logo too.
    const clientLogo = clientResolved && clientLogoUrl && clientLogoUrl !== failedLogoUrl ? clientLogoUrl : null

    // The container renders unconditionally so its min-height reservation keeps the page from
    // jumping when the logo resolves.
    return (
        <div className="dashboard-placeholder">
            {clientLogo ? (
                <img className="client-logo" src={clientLogo} alt={scopedClient.name} onError={() => setFailedLogoUrl(clientLogo)} />
            ) : (
                clientResolved && <img src={mucLogoUrl} alt="My Utility Cloud" />
            )}
        </div>
    )
}
